import * as History from 'history'
import React from 'react'
import { Link } from 'react-router-dom'

import TextButton from 'components/common/TextButton'
import Icon from 'components/Icon'
import theme from 'theme'

const UpperBackText: React.FC<{
  to?: History.LocationDescriptor
  onClick?(): void
}> = ({ children, to, onClick }) => {
  const Component = to ? Link : TextButton

  return (
    <div css={{ marginBottom: theme.space[2] }}>
      <Component
        css={{
          fontSize: theme.fontSizes[2],
          display: 'inline-grid',
          gridAutoFlow: 'column',
          gridAutoColumn: 'auto',
          gap: theme.space[1],
          alignItems: 'center',
          justifyItems: 'start'
        }}
        to={to}
        onClick={onClick}
      >
        <Icon icon="chevronLeft" />
        {children}
      </Component>
    </div>
  )
}

export default UpperBackText
